import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EECF7D",
      d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M12 3.209A8.791 8.791 0 1 0 20.791 12 8.801 8.801 0 0 0 12 3.209Zm0 16.72A7.929 7.929 0 1 1 19.929 12 7.937 7.937 0 0 1 12 19.929Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M16.166 9.346a.431.431 0 0 0 0-.86h-2.485V6.329a.432.432 0 1 0-.86 0v2.155h-1.718V6.328a.43.43 0 0 0-.604-.433.431.431 0 0 0-.256.433v2.155H7.772a.431.431 0 0 0-.432.432v6.088a.431.431 0 0 0 .432.434h2.46v2.216a.431.431 0 0 0 .859 0v-2.215h1.719v2.215a.432.432 0 0 0 .859 0v-2.215h2.497a.431.431 0 0 0 .43-.432v-3.16a.428.428 0 0 0-.43-.432h-5.491a.43.43 0 0 0 0 .86h5.06v2.304H8.202V9.346h7.964Z"
    }, null, -1)
  ])))
}
export default { render: render }